<section *ngIf="!loadingData else noLoading">
    <div class="z-index-search position-relative">
        <img [src]="imgPath+supportAndBlogCategory.img_banner" alt="image" class="img-fluid w-100"
            *ngIf="supportAndBlogCategory.img_banner  != null">
        <div class="categoryS-header" *ngIf="supportAndBlogCategory.img_banner  == null ">
        </div>
        <div class="input-main-title-overlay">
            <div class="container">
                <div class="text-shad title" *ngIf="description"
                    [innerHTML]="supportAndBlogCategory.ser_description | sanitizeHtmlPages:'html'">
                </div>
                <div class="position-relative search-shadow">
                    <mat-icon class="search-icon" [ngStyle]="
                {'right': Common.isRtl ? '10px' : 'auto', 'left': Common.isRtl ? 'auto' : '10px'}">search</mat-icon>
                    <mat-icon [ngStyle]="isDropdownVisible ? 
                {'display': 'block', 'left': Common.isRtl ? '10px' : 'auto', 'right': Common.isRtl ? 'auto' : '10px'} : 
                {'display': 'none'}" class="search-icon search-position" (click)="clearInputSearch()">close</mat-icon>
                    <input #searchE type="text" class="form-control" [placeholder]="'search placeholder'|translate"
                        [ngStyle]="{'padding-right': Common.isRtl ? '40px' : '10px','padding-left': Common.isRtl ? '10px' : '40px'}"
                        style="border-radius: 10px;" [(ngModel)]="searchData"
                        (input)="getSearchSupportPage(searchE.value)" (focus)="getSearchSupportPage(searchE.value)">
                    <div class="shadow search-dropdown" *ngIf="isDropdownVisible">
                        <app-search-drop [loadingSearch]="loadingSearch" [searchList]="searchList"></app-search-drop>
                    </div>
                </div>
            </div>
        </div>
    </div>


    <div class="container">
        <!-- <div *ngIf="supportAndBlogCategory.img_banner !=null">
            <img [src]="imgPath+supportAndBlogCategory.img_banner" class="mx-auto img-fluid d-block"
                alt=" defaultImage">
        </div> -->

        <!-- <h3 class="my-3 text-center">
            {{supportAndBlogCategory.name}}
        </h3> -->


        <div class="mt-5 row">
            <div class="mb-2 col-xl-3 col-md-4 col-sm-6" *ngFor="let item of supportAndBlogCategory.sub">
                <div class="category-container">
                    <img [routerLink]="'/pages/support-category-page/category/'+item.id+'/'+item.name.split(' ').join('-')"
                        [src]="item.img_banner ? imgPath+item.img_banner : 'assets/images/product/placeholder.jpg'"
                        class="mb-2 cursor-pointer img-fluid sub-img" style="max-height: 150px; width: 100%;"
                        alt="defaultImage" (error)="handleImageError($event.target)">
                    <div class="px-2">
                        <div class="cursor-pointer item-header"
                            [routerLink]="'/pages/support-category-page/category/'+item.id+'/'+item.name.split(' ').join('-')">
                            <img [src]="item.img ? imgPath+item.img : 'assets/images/product/placeholder.jpg'"
                                class="img-fluid" alt=" defaultImage" (error)="handleImageError($event.target)"
                                style="width: 20px; height: 20px;">

                            <h4 class="main-color-title">{{item.name}}</h4>
                        </div>
                        <div class="my-2 text-start sub-description">{{item.ser_description |stripHtml}}
                        </div>
                        <div class="article-container">
                            <a
                                [routerLink]="'/pages/support-category-page/category/'+item.id+'/'+item.name.split(' ').join('-')">{{'sub
                                Categories'|translate}} ({{item.sub_count}})</a>
                        </div>
                        <div class="cursor-pointer sub-container" *ngFor="let sub of item.sub"
                            [routerLink]="'/pages/support-category-page/category/'+sub.id+'/'+sub.name.split(' ').join('-')">
                            <img [src]="sub.img ? imgPath+sub.img : 'assets/images/product/placeholder.jpg'"
                                class="img-fluid" alt=" defaultImage" (error)="handleImageError($event.target)"
                                style="width: 20px; height: 20px;">
                            <p class="main-color-title">{{sub.name}}</p>
                        </div>
                        <a [routerLink]="'/pages/support-category-page/category/'+item.id+'/'+item.name.split(' ').join('-')"
                            class="text-end show-all-category-btn" *ngIf="item.sub_count >0">{{'show
                            all
                            categories'|translate}}
                            <span></span>
                        </a>
                    </div>
                </div>
            </div>

        </div>
    </div>
</section>
<ng-template #noLoading>
    <div class="my-5 all d-flex justify-content-center align-items-center">
        <img src="assets/images/loader.gif">
    </div>

</ng-template>